import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import DataTable from '../datatable'
import InterviewStatus, { statusList, statusColor } from '../interview/status'
import { InterviewEvents, InterviewApprovals, InterviewTasks } from '../interview/info'

const opcos = {
  FI: 'FI',
  US: 'US',
  SE: 'SE',
  G: 'G',
}

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    link(item) {
      return `/project/${item.get('project_id')}/interview/${item.get('id')}`
    },
  },
  {
    name: 'project_name',
    sortable: true,
    label: 'Projekti',
    render(i) {
      return <Link to={`/project/${i.get('project_id')}`}>{i.get('project_name')}</Link>
    },
  },
  {
    name: 'organization_name',
    sortable: true,
    label: 'Organisaatio',
    render(i) {
      return (
        <Link to={`/organization?editId=${i.get('organization_id')}&search=${i.get('name')}`}>
          {i.get('organization_name')}
        </Link>
      )
    },
  },
  {
    name: 'status',
    label: 'Status',
    sortable: true,
    width: 180,
    render(i) {
      return <InterviewStatus interview={i} />
    },
  },
  {
    name: 'info',
    label: 'Info',
    width: 300,
    render(i) {
      return (
        <div className="coordination-status">
          <InterviewEvents interview={i} />
          <InterviewApprovals interview={i} />
          <InterviewTasks interview={i} />
        </div>
      )
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
  {
    name: 'updated_at',
    label: 'Päivitetty',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
  {
    name: 'project_operating_company_id',
    label: 'OPCO',
    width: 100,
    sortable: true,
  },
]

const filterFields = [
  {
    name: 'status',
    type: 'buttons',
    label: 'Tila',
    multiple: true,
    options: Object.keys(statusList).map(k => ({
      value: k,
      label: statusList[k],
    })),
  },
  {
    type: 'group',
    placeholder: 'OPCO',
    icon: 'building',
    fields: [
      {
        name: 'operating_company_id',
        type: 'checkboxes',
        label: 'OPCO',
        options: Object.keys(opcos).map(key => ({ value: key, label: opcos[key] })),
      },
    ],
  },
]

export default function ProjectRoot() {
  return (
    <DataTable
      id="interviews"
      entity="interview"
      title="Haastattelut"
      sortDir="desc"
      apiPath="/coordination"
      filters
      limit={20}
      filterFields={filterFields}
      columns={columns}
    />
  )
}
